// extracted by mini-css-extract-plugin
export default {"AuthContainer":"Auth_AuthContainer__QbyWo","User":"Auth_User__ONJEE","AuthBtn":"Auth_AuthBtn__XXUXv","BtnIcon":"Auth_BtnIcon__6WIeE","BtnText":"Auth_BtnText__vqT+I"};